package org.chiangmeng.qfast.core.domain.usecases

import kotlinx.coroutines.flow.Flow
import org.chiangmeng.qfast.core.domain.models.QueueTicket
import org.chiangmeng.qfast.core.domain.ports.QueueRepository

class ObserveActiveQueuesUseCase(private val repository: QueueRepository) {
    operator fun invoke(shopId: String): Flow<List<QueueTicket>> = repository.observeActiveQueues(shopId)
}